<template>
  <div :class="cls">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'mx-button-group',
  props: {
    shape: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      cls: ''
    };
  },
  mounted() {
    this.cls = `mx-button-group ${this.shape} ${this.type}`;
  }
};
</script>
